import React, { Fragment } from 'react';
import PageTitle from '../../components/pagetitle';
import Footer from '../../components/footer';
import Scrollbar from '../../components/scrollbar';
import ExecutiveCommittee from '../../components/ExecutiveCommittee';

const HaabPage = () => {
  return (
    <Fragment>
      <PageTitle pageTitle={'Committee of HAAB'} />
      <ExecutiveCommittee association='HAAB' />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default HaabPage;
